module.exports = __webpack_public_path__ + "img/gentlemen-club-team-2.008f9d99.png";